/* Cura — Product Details: make the Composition card equal the General
   Information card's height. If longer, clamp behind Read more/Read less.
   If shorter, stretch to match. */
(function () {
  'use strict';

  function setup(section) {
    var panels = section.querySelector('.cura-pd__panels');
    if (!panels) return;

    var cards = section.querySelectorAll('.cura-pd__panel');
    if (cards.length < 2) return;

    var leftCard  = cards[0]; // General Information
    var rightCard = cards[1]; // Composition
    var clamp     = section.querySelector('[data-pd-clamp]');
    var toggle    = section.querySelector('[data-pd-toggle]');
    var moreLbl   = section.querySelector('[data-pd-toggle-more]');
    var lessLbl   = section.querySelector('[data-pd-toggle-less]');
    if (!clamp || !toggle) return;

    var expanded = false;

    function isStacked() {
      return window.getComputedStyle(panels).gridTemplateColumns.split(' ').length < 2;
    }

    function reset() {
      clamp.classList.remove('is-clamped');
      clamp.style.removeProperty('--pd-clamp-height');
      rightCard.style.removeProperty('min-height');
    }

    function apply() {
      reset();

      if (isStacked()) {
        // Mobile: natural height, no clamp, no stretch, no button.
        toggle.hidden = true;
        return;
      }

      var target = leftCard.getBoundingClientRect().height;

      if (expanded) {
        toggle.hidden = false;
        return;
      }

      // Right card height with the clamp at natural size.
      var rightTotal = rightCard.getBoundingClientRect().height;
      var clampCurrent = clamp.getBoundingClientRect().height;
      var chrome = rightTotal - clampCurrent;      // title + serving + note + button + paddings
      var maxClamp = target - chrome;
      var natural = clamp.scrollHeight;

      if (natural > maxClamp + 4 && maxClamp > 60) {
        // Composition is TALLER → clamp it and show Read more.
        clamp.style.setProperty('--pd-clamp-height', maxClamp + 'px');
        clamp.classList.add('is-clamped');
        toggle.hidden = false;
      } else {
        // Composition is SHORTER (or equal) → stretch card to match, no button.
        toggle.hidden = true;
        if (rightTotal < target - 1) {
          rightCard.style.minHeight = target + 'px';
        }
      }
    }

    toggle.addEventListener('click', function () {
      expanded = !expanded;
      if (expanded) {
        reset();
        if (moreLbl) moreLbl.hidden = true;
        if (lessLbl) lessLbl.hidden = false;
      } else {
        if (moreLbl) moreLbl.hidden = false;
        if (lessLbl) lessLbl.hidden = true;
      }
      apply();
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    });

    requestAnimationFrame(function () { requestAnimationFrame(apply); });
    window.addEventListener('load', apply);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.cura-pd').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();